
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

const HEADER_STYLE = {
  fill: { patternType: "solid", fgColor: { rgb: "C72127" } },
  font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
  alignment: { horizontal: "center", vertical: "center", wrapText: true },
  border: {
    top:    { style: "thin", color: { rgb: "000000" } },
    bottom: { style: "thin", color: { rgb: "000000" } },
    left:   { style: "thin", color: { rgb: "000000" } },
    right:  { style: "thin", color: { rgb: "000000" } },
  },
};

const DATA_STYLE = {
  fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } },
  font: { color: { rgb: "2D3748" }, sz: 11 },
  alignment: { horizontal: "left", vertical: "center", wrapText: true },
  border: {
    top:    { style: "thin", color: { rgb: "000000" } },
    bottom: { style: "thin", color: { rgb: "000000" } },
    left:   { style: "thin", color: { rgb: "000000" } },
    right:  { style: "thin", color: { rgb: "000000" } },
  },
};

export function exportToExcel({ headers, fields, data, sheetName = "Report", fileName = "report" }) {
  const wsData = [
    headers.map((h) => ({ v: h, t: "s", s: HEADER_STYLE })),
    ...data.map((row) =>
      fields.map((f) => ({
        v: row[f] !== undefined && row[f] !== null ? String(row[f]) : "",
        t: "s",
        s: DATA_STYLE,
      }))
    ),
  ];

  const ws       = XLSX.utils.aoa_to_sheet(wsData);
  ws["!cols"]    = headers.map(() => ({ wch: 20 }));
  ws["!rows"]    = [{ hpt: 30 }, ...data.map(() => ({ hpt: 22 }))];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([buf], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${fileName}.xlsx`
  );
}